module.exports = __webpack_public_path__ + "static/2_2-901ae557b29bf2f2a9ed9753f56986b7.jpg";